export class LanguageStore {
    static allLanguages = {};
}